<template>
  <div class="w-full">
    <div v-if="statuses.length > 0">
      <status v-for="item in statuses" :key="'status_'+codeLayer+'_'+item.id"
        :status="item"
        :visibility="visibility"
        @epc-edit-status="_handleEditStatus"
        @epc-delete-status="_HandleDeleteElement"
      />
    </div>
    <div v-else class="flex flex-row bg-grey-light border hover:border-blue rounded">
      <p class="text-center w-full">No tiene estados definidos</p>
    </div>

    <!-- currentLayer && currentLayer.code == codeLayer -->
    <!-- Contenedor del botón "Añadir estado". Se quitó la clase Bulma `panel-tabs`
         (pensada para pestañas dentro de un .panel): traía la franja/estilo de pestaña.
         Ahora es un simple flex centrado con separación superior suave. -->
    <div v-if="showBtnAddStatus"
      class="flex justify-center border-t border-gray-100 mt-4 pt-3">
        <b-button type="is-primary" size="is-small"
          @click="_handleClickedAddStatus"
        >{{ $t('add_status') }}</b-button>
    </div>

    <status-form-modal :ref="'refStatusFormModal'"
      @epc-status-add="_HandleAddStatus"
    />
  </div>
</template>

<script>

import Status from "./status.vue";
import StatusForm from "./status-form.vue";
import StatusFormModal from "./status-form-modal.vue";

// import { UpdateLayerStatusesKey } from "../layer-statuses/layer-statuses-list.vue";

export default {
  name: "Statuses",

  // Inyecciones del manager (LayerStatusesManager).
  // Cada una retorna Promise. Si el manager no está montado arriba (uso aislado),
  // reciben null y los handlers retornan temprano con warning.
  inject: {
    AddStatus:      { from: 'AddStatus',      default: null },
    UpdateStatus:   { from: 'UpdateStatus',   default: null },
    DeleteStatus:   { from: 'DeleteStatus',   default: null },
    AddIncident:    { from: 'AddIncident',    default: null },
    UpdateIncident: { from: 'UpdateIncident', default: null },
    DeleteIncident: { from: 'DeleteIncident', default: null },
  },

  components: {
    Status,
    StatusForm,
    StatusFormModal,
  },

  props: {
    statuses: { type: Array, required: true },
    typeStatus: { type: String, default: "status" },
    codeLayer: { type: String, required: true },
    layerId: { type: Number, required: true },
    groupId: { type: Number, default: null },
    showBtnAddStatus: { type: Boolean, default: true },
    weightingCriteria: { type: String, default: null },
    visibility: { type: String, default: 'visible_default' },
    visibilityRoles: { type: Array, default: () => [] },
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    // Helpers de mutadores según typeStatus — abstraen 'status' vs 'incident'
    addMutator()    { return this.typeStatus === 'incident' ? this.AddIncident    : this.AddStatus; },
    updateMutator() { return this.typeStatus === 'incident' ? this.UpdateIncident : this.UpdateStatus; },
    deleteMutator() { return this.typeStatus === 'incident' ? this.DeleteIncident : this.DeleteStatus; },
  },

  methods: {
    // Método público — el padre (group-statuses) lo llama para abrir el modal directamente.
    openAddModal() {
      this._handleClickedAddStatus();
    },

    _handleClickedAddStatus() {
      this.$refs.refStatusFormModal.show({
        id: null,
        layer_id: this.layerId,
        group_id: this.groupId,
        code: null,
        name: null,
        color: null,
        weight: null,
        type: this.typeStatus,
        is_completion: false
      }, this.visibility, this.weightingCriteria);
    },

    _handleEditStatus(data) {
      // this.status = data.status
      data.status.layer_id = this.layerId;
      this.$refs.refStatusFormModal.show(data.status, this.visibility, this.weightingCriteria);
    },

    /**
     * El modal de crear/editar status emite con un payload puro.
     * Distinguimos por id:
     *   - id null → addMutator (AddStatus o AddIncident)
     *   - id > 0  → updateMutator
     */
    async _HandleAddStatus(payload) {
      if (!this.addMutator || !this.updateMutator) {
        console.warn('[statuses] inject del manager no disponible');
        return;
      }
      const { id, ...rest } = payload;
      try {
        if (id && id > 0) {
          await this.updateMutator(id, rest);
        } else {
          await this.addMutator(rest);
        }
        this.$toast.open({
          message: this.$t('status_change_success'),
          type: 'is-success',
          position: 'is-top-right',
        });
      } catch (err) {
        this.$toast.open({
          message: err.error_msg || this.$t('status_change_fail'),
          type: 'is-danger',
          position: 'is-top-right',
        });
      }
    },

    async _HandleDeleteElement({ status }) {
      if (!this.deleteMutator) {
        console.warn('[statuses] inject deleteMutator no disponible');
        return;
      }
      try {
        await this.deleteMutator(status.id);
        this.$toast.open({
          message: this.$t('status_deleted_successfully'),
          type: 'is-success',
          position: 'is-top-right',
        });
      } catch (err) {
        this.$toast.open({
          message: err.error_msg || this.$t('error_deleting_status'),
          type: 'is-danger',
          position: 'is-top-right',
        });
      }
    },
  },
};
</script>
